export default __webpack_public_path__ + "static/media/bx-chevron-up-gray.4db50777.svg";